import { TextInput } from '@codecorp/components'
import { useMaskito } from '@maskito/react'
import { usePhoneMask } from '../phone'

export const PhoneInput = ({
    name,
    id,
    defaultValue,
    customValidity,
}: {
    name: string
    id: string
    defaultValue?: string
    customValidity?: string
}) => {
    const options = usePhoneMask()
    const ref = useMaskito({ options })

    return (
        <TextInput
            name={name}
            id={id}
            ref={ref}
            autoComplete="tel"
            defaultValue={defaultValue}
            // don't let them edit until the mask is loaded
            disabled={!options}
            customValidity={customValidity}
        />
    )
}
